import ReactPDF, { Text, View } from "@react-pdf/renderer";
import * as React from "react";
import NumberFormatter from "../../../../model/common/NumberFormatter";
import { IReport7ApplicantPresentationModel } from "../../../../presenter/report/model/Report7ApplicantPresentationModel";
import { TTranslate } from "../../../../service/locale/TranslationService";

const Report7PDFTemplateNumericalValuesGrid = ({
  translate,
  styles,
  applicant
}: {
  translate: TTranslate;
  styles: ReactPDF.Styles;
  applicant: IReport7ApplicantPresentationModel;
}) => {
  const numericValues = applicant.numericValues;

  return (
    <View style={styles.table}>
      <View style={styles.tableRow}>
        <View style={{ ...styles.tableCol, width: "50%" }}>
          <Text style={styles.tableCell}>
            {translate("report7_preview.form_structure_element")}
          </Text>
        </View>
        <View style={{ ...styles.tableCol, width: "25%" }}>
          <Text style={{ ...styles.tableCell, textAlign: "right" }}>
            {translate("report7_preview.amount")}
          </Text>
        </View>
        <View style={{ ...styles.tableCol, width: "25%" }}>
          <Text style={{ ...styles.tableCell, textAlign: "right" }}>
            {translate("report7_preview.number_of_numeric_values")}
          </Text>
        </View>
      </View>
      {numericValues.map((item, index) => (
        <View key={index}>
          <View style={styles.tableRow} key={index}>
            <View style={{ ...styles.tableCol, width: "50%" }}>
              <Text style={styles.tableCell}>
                {item.formStructureSectionName}
              </Text>
            </View>
            <View style={{ ...styles.tableCol, width: "25%" }}>
              <Text style={{ ...styles.tableCell, textAlign: "right" }}>
                {NumberFormatter().formatReadOnlyValue(item.amount)}
              </Text>
            </View>
            <View style={{ ...styles.tableCol, width: "25%" }}>
              <Text style={{ ...styles.tableCell, textAlign: "right" }}>
                {item.numberOfNumericValues}
              </Text>
            </View>
          </View>
        </View>
      ))}
    </View>
  );
};

export default Report7PDFTemplateNumericalValuesGrid;
